<template>
  <div class="landing-page">
    <!-- 2. Hero Section -->
    <section class="hero-section"
      :style="{ backgroundImage: `url('https://qiniu-au.wifigsmalarm.com/images/home_banner.png')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
      <div class="hero-container">
        <!-- 左侧文字内容 (左滑入) -->
        <div class="hero-content animate-slide-in-left">
          <h1 v-html="t('hero.title')"></h1>
          <p class="hero-description">{{ t('hero.desc') }}</p>
        </div>

        <!-- 右侧图片 (右滑入) -->
        <div class="hero-image-wrapper animate-slide-in-right">
          <!-- 这里替换为你实际的手机App预览图图片名，例如 'hero_app' -->
          <img src="https://qiniu-au.wifigsmalarm.com/images/home.png" style="margin-top: 5vh;" alt="Smart Home App"
            class="hero-image" />
        </div>
      </div>
    </section>

    <section class="section text-center bg-light overflow-hidden">
      <h2 class="section-title" v-scroll-reveal>{{ t('about.title') }}</h2>
      <div class="feature-rows" style="text-align: left;">
        <div class="feature-row reverse-row">
          <div class="feature-content slide-left" v-scroll-reveal>
            <p>{{ t('about.desc1') }}</p>
            <p>{{ t('about.desc2') }}</p>
            <p>{{ t('about.desc3') }}</p>
          </div>
          <img class="feature-image slide-left" style="height: 600px;"
            src="https://qiniu-au.wifigsmalarm.com/images/about.png" v-scroll-reveal />
        </div>
      </div>
    </section>

    <!-- 3. Control Your Way -->
    <section class="section text-center bg-light overflow-hidden">
      <h2 class="section-title" v-scroll-reveal>{{ t('protocol.title') }}</h2>
      <div class="grid-container grid-3">
        <div class="card" v-for="(card, index) in controlCards" :key="index" v-scroll-reveal
          :style="{ transitionDelay: `${index * 150}ms` }">
          <img class="card-icon" :src="getAssetIcon(card.icon)" />
          <h3>{{ card.title }}</h3>
          <p>{{ card.desc }}</p>
        </div>
      </div>
    </section>
    <section class="section text-center overflow-hidden awesome-features">
      <div class="awesome-header" v-scroll-reveal>
        <h2 class="section-title">{{ t('features.title') }}</h2>
      </div>

      <div class="awesome-content">
        <!-- 左侧特性卡片群 -->
        <div class="awesome-column left-column">
          <!-- 注意：slide-right 的意思是“向右滑动”，刚好对应从屏幕左侧外边飞入 -->
          <div class="awesome-card reveal-before-enter slide-right" v-for="(feat, index) in leftAwesomeFeatures"
            :key="'left-' + index" v-scroll-reveal :style="{ transitionDelay: `${index * 150}ms` }">
            <div class="feat-icon">
              <svg v-if="index === 0" t="1790590585840" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="2717" width="70" height="70">
                <path
                  d="M843.2 744.64a160 160 0 0 0-161.92-152 177.28 177.28 0 0 0-340.48 3.84h-8.64a160 160 0 0 0 0 317.12v1.92l374.72-4.16v-2.56a160 160 0 0 0 136.32-164.16z"
                  fill="#0987fc" p-id="2718"></path>
                <path d="M608.64 452.16m-33.28 0a33.28 33.28 0 1 0 66.56 0 33.28 33.28 0 1 0-66.56 0Z" fill="#0987fc"
                  p-id="2719"></path>
                <path
                  d="M856.32 385.92l28.8-10.88a249.6 249.6 0 0 0-273.6-207.68L608 198.4a219.52 219.52 0 0 1 247.68 185.6 9.28 9.28 0 0 0 0.64 1.92z"
                  fill="#0987fc" p-id="2720"></path>
                <path
                  d="M800 408a182.72 182.72 0 0 0-200.32-147.84l-4.16 32h2.24a152.64 152.64 0 0 1 173.12 128zM714.24 440.96A113.92 113.92 0 0 0 587.84 352l-3.84 29.76a15.68 15.68 0 0 0 6.72 0 83.52 83.52 0 0 1 96 68.16z"
                  fill="#0987fc" p-id="2721"></path>
              </svg>

              <svg v-if="index === 1" t="1790591031111" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="3732" width="70" height="70">
                <path
                  d="M902 139.2v457.1c0 27.4-6.5 54.7-19.5 81.8-13 27.2-30 53.4-51.1 78.9-21.1 25.5-45.1 49.6-72.2 72.3-27.1 22.8-54.5 43.1-82.3 60.8-27.8 17.8-54.9 32.6-81.1 44.4s-49.3 19.9-69 24.3l-9.4 1.6-8.6-1.6c-20.3-4.4-43.8-12.5-70.6-24.3-26.8-11.8-54.6-26.6-83.5-44.4-28.9-17.8-57.2-38.1-85-60.8-27.8-22.7-52.7-46.9-74.5-72.3-21.8-25.5-39.5-51.8-53-78.9-13.5-27.1-20.2-54.4-20.2-81.8V139.2l32-5 358.8-70.7 365.8 70.7 23.4 5z m-389.1-9.5l-4.3-0.9-308 55.2v288.4h312.3V129.7z m310.5 342.7H512.9v410.5c20-4.8 41.7-12.2 65.2-22.2 23.4-9.9 46.6-21.7 69.5-35.3 22.9-13.6 44.9-28.6 66.1-45.2 21.2-16.6 39.9-34.4 56.2-53.4 16.3-19 29.3-38.7 39-59.2 9.8-20.5 14.6-41.3 14.6-62.4V472.4h-0.1z"
                  p-id="3733" fill="#0987fc"></path>
              </svg>

              <svg v-if="index === 2" t="1790591128686" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4764" width="70" height="70">
                <path
                  d="M85.333333 810.666667c0-23.466667 19.2-42.666667 42.666667-42.666667h42.666667v-192c0-187.733333 153.6-341.333333 341.333333-341.333333s341.333333 153.6 341.333333 341.333333v192h42.666667c23.466667 0 42.666667 19.2 42.666667 42.666667v149.333333c0 23.466667-19.2 42.666667-42.666667 42.666667H128c-23.466667 0-42.666667-19.2-42.666667-42.666667v-149.333333z m85.333334 42.666666v64h682.666666v-64H170.666667z m85.333333-277.333333v192h512v-192c0-140.8-115.2-256-256-256s-256 115.2-256 256zM469.333333 64v85.333333c0 23.466667 19.2 42.666667 42.666667 42.666667s42.666667-19.2 42.666667-42.666667V64c0-23.466667-19.2-42.666667-42.666667-42.666667s-42.666667 19.2-42.666667 42.666667M119.466667 183.466667c-17.066667 17.066667-17.066667 42.666667 0 59.733333l59.733333 59.733333c8.533333 8.533333 19.2 12.8 29.866667 12.8 10.666667 0 21.333333-4.266667 29.866666-12.8 17.066667-17.066667 17.066667-42.666667 0-59.733333L181.333333 183.466667c-17.066667-17.066667-44.8-17.066667-61.866666 0M844.8 183.466667l-59.733333 59.733333c-17.066667 17.066667-17.066667 42.666667 0 59.733333 8.533333 8.533333 19.2 12.8 29.866666 12.8 10.666667 0 21.333333-4.266667 29.866667-12.8l59.733333-59.733333c17.066667-17.066667 17.066667-42.666667 0-59.733333-17.066667-17.066667-44.8-17.066667-59.733333 0"
                  fill="#0987fc" p-id="4765"></path>
                <path
                  d="M648.533333 439.466667c-19.2-19.2-44.8-34.133333-70.4-44.8-21.333333-8.533333-46.933333 4.266667-55.466666 25.6s4.266667 46.933333 25.6 55.466666c14.933333 4.266667 27.733333 12.8 38.4 25.6 10.666667 10.666667 19.2 23.466667 25.6 38.4 6.4 17.066667 23.466667 27.733333 40.533333 27.733334 4.266667 0 10.666667 0 14.933333-2.133334 21.333333-8.533333 34.133333-32 25.6-55.466666-10.666667-25.6-25.6-49.066667-44.8-70.4"
                  fill="#0987fc" p-id="4766"></path>
              </svg>
            </div>
            <div class="feat-text">
              <h4>{{ feat.title }}</h4>
              <p>{{ feat.desc }}</p>
            </div>
          </div>
        </div>

        <!-- 中间手机产品图 -->
        <div class="awesome-column center-column" v-scroll-reveal.zoom>
          <!-- 替换为你的手机App界面截图图，假设叫 app_mockup -->
          <img class="phone-mockup" src="https://qiniu-au.wifigsmalarm.com/images/light.png" v-scroll-reveal />
        </div>

        <!-- 右侧特性卡片群 -->
        <div class="awesome-column right-column">
          <!-- 注意：slide-left 的意思是“向左滑动”，刚好对应从屏幕右侧外边飞入 -->
          <div class="awesome-card reveal-before-enter slide-left" v-for="(feat, index) in rightAwesomeFeatures"
            :key="'right-' + index" v-scroll-reveal :style="{ transitionDelay: `${index * 150}ms` }">
            <svg v-if="index === 0" t="1790591274132" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="5804" width="70" height="70">
              <path
                d="M323.332 490c-81.8 0-148.3-66.4-148.3-148.3v-2c0-81.8 66.4-148.3 148.3-148.3h2c81.8 0 148.3 66.4 148.3 148.3v105.6c0 24.8-19.8 44.6-44.6 44.6h-105.7z m0-260.8c-61.5 0-111.1 49.6-111.1 111.1v2c0 61 49.6 110.6 111.1 110.6h113.1V339.8c0-61.5-49.6-111.1-111.1-111.1h-2v0.5z m257.4 260.8c-24.8 0-44.6-19.8-44.6-44.6V339.8c0-81.8 66.4-148.3 148.3-148.3h2c81.8 0 148.3 66.4 148.3 148.3v2c0 81.8-66.4 148.3-148.3 148.3h-105.7z m104.1-260.8c-61.5 0-111.1 49.6-111.1 111.1v112.6h112.6c61.5 0 111.1-49.6 111.1-111.1v-2c0-61.5-49.6-111.1-111.1-111.1h-1.5v0.5z m-361.5 622.3c-81.8 0-148.3-66.4-148.3-148.3v-2c0-81.8 66.4-148.3 148.3-148.3h105.6c24.8 0 44.6 19.8 44.6 44.6v105.6c0 81.8-66.4 148.3-148.3 148.3h-1.9z m0-261.3c-61.5 0-111.1 49.6-111.1 111.1v2c0 61.5 49.6 111.1 111.1 111.1h2c61.5 0 111.1-49.6 111.1-111.1V590.2h-113.1z m361.5 261.3c-81.8 0-148.3-66.4-148.3-148.3V597.6c0-24.8 19.8-44.6 44.6-44.6h105.1c81.8 0 148.3 66.4 148.3 148.3v2c0 81.8-66.4 148.3-148.3 148.3h-1.4z m-111-148.2c0 61.5 49.6 111.1 111.1 111.1h2c61.5 0 111.1-49.6 111.1-111.1v-2c0-61.5-49.6-111.1-111.1-111.1h-113.1v113.1z"
                fill="#0987fc" p-id="5805"></path>
            </svg>
            <svg v-if="index === 1" t="1790591347467" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="6813" width="70" height="70">
              <path
                d="M896 473.6a38.4 38.4 0 0 1 38.4 38.4 422.4 422.4 0 0 1-790.656 207.04 38.4 38.4 0 0 1 27.072-56.704l9.472-0.704h102.4a38.4 38.4 0 0 1 6.272 76.288l-6.272 0.512H250.88A345.6 345.6 0 0 0 857.6 512a38.4 38.4 0 0 1 38.4-38.336zM539.328 342.848l122.048 310.208h-69.184l-29.632-77.952H456.832L427.2 653.056h-68.8l122.112-310.208h58.816zM512 89.6a422.336 422.336 0 0 1 376 229.76 38.4 38.4 0 0 1-16.64 51.648l-3.456 1.536-3.52 1.28a36.8 36.8 0 0 1-7.552 1.984l-6.208 0.512h-102.4a38.4 38.4 0 0 1-6.208-76.288l6.208-0.512h36.416A345.6 345.6 0 0 0 166.4 512a38.4 38.4 0 1 1-76.8 0A422.4 422.4 0 0 1 512 89.6z m-2.048 346.432l-30.784 80.192h61.12l-30.336-80.192z"
                fill="#0987fc" p-id="6814"></path>
            </svg>
            <svg v-if="index === 2" t="1790591399575" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="7973" width="70" height="70">
              <path
                d="M341.5 447.8c-75 0-136-61-136-136s61-136 136-136 136 61 136 136-61 136-136 136z m0-208c-39.7 0-72 32.3-72 72s32.3 72 72 72 72-32.3 72-72-32.3-72-72-72zM685.3 452.8c-75 0-136-61-136-136s61-136 136-136 136 61 136 136-61 136-136 136z m0-208c-39.7 0-72 32.3-72 72s32.3 72 72 72 72-32.3 72-72-32.3-72-72-72zM96.1 756.2c-17.7 0-32-14.3-32-32 0-73.7 28.7-143 80.8-195.1C197 477 266.3 448.3 340 448.3c42.9 0 84 9.6 122.2 28.5 15.8 7.8 22.3 27 14.5 42.9s-27 22.3-42.9 14.5c-29.3-14.5-60.9-21.9-93.8-21.9-116.8 0-211.9 95.1-211.9 211.9 0 17.7-14.3 32-32 32zM927.7 761.2c-17.7 0-32-14.3-32-32 0-116.8-95.1-211.9-211.9-211.9-32.9 0-64.3 7.3-93.5 21.7-15.9 7.8-35 1.3-42.9-14.5-7.8-15.9-1.3-35 14.5-42.9 38.1-18.8 79.1-28.3 121.8-28.3 73.7 0 143 28.7 195.1 80.8 52.1 52.1 80.8 121.4 80.8 195.1 0.1 17.7-14.2 32-31.9 32z"
                fill="#0987fc" p-id="7974"></path>
              <path
                d="M511 629.4c-54.5 0-98.9-44.4-98.9-98.9s44.4-98.9 98.9-98.9 98.9 44.4 98.9 98.9-44.4 98.9-98.9 98.9z m0-133.8c-19.2 0-34.9 15.7-34.9 34.9s15.7 34.9 34.9 34.9 34.9-15.7 34.9-34.9-15.7-34.9-34.9-34.9zM666.1 849.2c-17.7 0-32-14.3-32-32 0-67.9-55.2-123.1-123.1-123.1-67.9 0-123.1 55.2-123.1 123.1 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-103.2 83.9-187.1 187.1-187.1 103.2 0 187.1 83.9 187.1 187.1 0 17.7-14.3 32-32 32z"
                fill="#0987fc" p-id="7975"></path>
            </svg>
            <div class="feat-text">
              <h4>{{ feat.title }}</h4>
              <p>{{ feat.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 4. Advanced Features -->
    <section class="section overflow-hidden">
      <h2 class="section-title text-center" v-scroll-reveal>{{ t('services.title') }}</h2>
      <div class="feature-rows">
        <div class="feature-row" v-for="(feature, index) in advancedFeatures" :key="index"
          :class="{ 'reverse-row': index % 2 !== 0 }">
          <div class="feature-content" v-scroll-reveal :class="index % 2 === 0 ? 'slide-right' : 'slide-left'">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.desc }}</p>
          </div>
          <img :src="getAssetImage(feature.icon)" class="feature-image" v-scroll-reveal.zoom
            :class="index % 2 === 0 ? 'slide-left' : 'slide-right'" />
        </div>
      </div>
    </section>

    <!-- 5. Get Started -->
    <section class="section bg-light overflow-hidden">
      <h2 class="section-title text-center" v-scroll-reveal>{{ t('software.title') }}</h2>
      <div class="grid-container grid-3">
        <div class="step-card" v-for="(step, index) in steps" :key="index" v-scroll-reveal
          :style="{ transitionDelay: `${index * 100}ms`, cursor: 'pointer' }" :class="{ 'is-clickable': step.link }"
          @click="handleCardClick(step)">
          <img class="step-img" :src="getAssetIcon(step.icon)" />
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>

          <div v-if="step.qrCode" class="qr-overlay">
            <img :src="step.qrCode" alt="QR" class="qr-img" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
// ✨ 1. 引入 computed
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const iconModules = import.meta.glob('../assets/icons/*.png', { eager: true });
const imageModules = import.meta.glob('../assets/home/*.png', { eager: true });

const getAssetIcon = (name) => {
  const globPath = `../assets/icons/${name}.png`;
  if (iconModules[globPath]) {
    return iconModules[globPath].default;
  } else {
    console.warn(`Icon ${name} not found, displaying default.`);
    return;
  }
}

const getAssetImage = (name) => {
  const globPath = `../assets/home/${name}.png`;
  if (imageModules[globPath]) {
    return imageModules[globPath].default;
  } else {
    console.warn(`Image ${name} not found, displaying default.`);
    return;
  }
}

const vScrollReveal = {
  mounted: (el, binding) => {
    const isZoom = binding.modifiers.zoom
    el.classList.add(isZoom ? 'reveal-zoom-before-enter' : 'reveal-before-enter')

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('reveal-enter')
          observer.unobserve(el)
        }
      })
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    })
    observer.observe(el)
  }
}

const leftAwesomeFeatures = computed(() => [
  { icon: 'design', title: t('features.remoteControl.title'), desc: t('features.remoteControl.desc') },
  { icon: 'customize', title: t('features.armDisarm.title'), desc: t('features.armDisarm.desc') },
  { icon: 'bootstrap', title: t('features.alarmPush.title'), desc: t('features.alarmPush.desc') }
])

// 右侧特性卡片数据
const rightAwesomeFeatures = computed(() => [
  { icon: 'colors', title: t('features.scenes.title'), desc: t('features.scenes.desc') },
  { icon: 'seo', title: t('features.automation.title'), desc: t('features.automation.desc') },
  { icon: 'support', title: t('features.familyShare.title'), desc: t('features.familyShare.desc') }
])

// ✨ 2. 使用 computed 包装数据数组，内部使用 t() 映射语言包的 key
const controlCards = computed(() => [
  { icon: 'zigbee', color: '#ff4d4f', title: 'Zigbee 3.0', desc: t('protocol.cards.zigbee') },
  { icon: 'wifi', color: '#1890ff', title: 'Wi-Fi', desc: t('protocol.cards.wifi') },
  { icon: '433', color: '#1890ff', title: '433MHz', desc: t('protocol.cards.rf433') },
  { icon: 'modbus', color: '#1890ff', title: 'Modbus', desc: t('protocol.cards.modbus') },
  { icon: 'knx', color: '#1890ff', title: 'KNX', desc: t('protocol.cards.knx') },
  { icon: 'bluetooth', color: '#1890ff', title: 'Bluetooth', desc: t('protocol.cards.bluetooth') }
])

const advancedFeatures = computed(() => [
  { icon: 'card_home', title: t('services.features.smartHome.title'), desc: t('services.features.smartHome.desc') },
  { icon: 'card_safe', title: t('services.features.security.title'), desc: t('services.features.security.desc') },
  { icon: 'card_hotel', title: t('services.features.hotel.title'), desc: t('services.features.hotel.desc') },
  { icon: 'card_building', title: t('services.features.building.title'), desc: t('services.features.building.desc') }
])

const steps = computed(() => [
  { icon: 'cms', title: t('software.steps.cms.title'), desc: t('software.steps.cms.desc'), link: 'https://new-cms.wifigsmalarm.com' },
  { icon: 'kooyii', title: t('software.steps.kooyii.title'), desc: t('software.steps.kooyii.desc'), qrCode: 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://vuejs.org/' },
  { icon: 'old', title: t('software.steps.elderly.title'), desc: t('software.steps.elderly.desc'), link: '/contact' },
  { icon: 'hotel', title: t('software.steps.hotel.title'), desc: t('software.steps.hotel.desc'), link: '/contact' },
  { icon: 'building', title: t('software.steps.building.title'), desc: t('software.steps.building.desc'), link: '/contact' },
  { icon: 'more', title: t('software.steps.more.title'), desc: t('software.steps.more.desc'), link: '/contact' }
])

const handleCardClick = (step) => {
  if (step.link) {
    window.open(step.link, '_blank')
  }
}
</script>

<style scoped>
/* --- 全局样式 --- */
.landing-page {

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #333;
  line-height: 1.6;
  overflow-x: hidden;
}

.placeholder-img {
  background-color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}

.text-center {
  text-align: center;
}

.bg-light {
  background-color: #f9fafb;
}

.section {
  padding: 80px 20px;
}

.section-title {
  font-size: 2.2rem;
  margin-bottom: 50px;
  font-weight: 700;
}

.overflow-hidden {
  overflow: hidden;
}

/* 防止左右飞入动画导致页面出现水平滚动条 */

/* =========================================
   动画核心 CSS 样式 
   ========================================= */

/* 1. 基础的【向上浮现】（文字、卡片常用） */
.reveal-before-enter {
  opacity: 0;
  transform: translateY(40px);
  /* 使用 ease-out 让动画结束时更柔和 */
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

/* 2. 【缩放+向上浮现】（图片、大图块常用） */
.reveal-zoom-before-enter {
  opacity: 0;
  transform: translateY(40px) scale(0.95);
  transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1), transform 1s cubic-bezier(0.16, 1, 0.3, 1);
}

/* （可选补充）左右滑入修饰类，结合上面的基础类使用 */
.reveal-before-enter.slide-right {
  transform: translateX(-40px);
}

.reveal-before-enter.slide-left {
  transform: translateX(40px);
}

.reveal-zoom-before-enter.slide-right {
  transform: translateX(-40px) scale(0.95);
}

.reveal-zoom-before-enter.slide-left {
  transform: translateX(40px) scale(0.95);
}

/* 3. 统一的【动画激活态】 */
.reveal-enter {
  opacity: 1 !important;
  transform: translate(0, 0) scale(1) !important;
}



.sub-nav {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 20px 0;
}

.sub-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.85rem;
  color: #666;
}

.sub-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-bottom: 8px;
}

.hero-section {
  background: #0987fc;
  /* 统一主题色背景 */
  width: 100%;
  min-height: 40vh;
  /* 保证第一屏高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  position: relative;
  overflow: hidden;
  /* 防止动画溢出产生滚动条 */
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1300px;
  /* 稍微放大整体最大宽度，给左右留出更多空间 */
  width: 100%;
  gap: 120px;
  /* ⬅️ 关键修改：将原来的 50px 拉大到 120px，增加图文间距 */
  margin: 0 auto;
}

/* 2. 左侧文字区：分配更多空间 */
.hero-content {
  flex: 1.1;
  /* ⬅️ 关键修改：让文字区占据多一点的比例 (原为1) */
  color: white;
  text-align: left;
  z-index: 2;
}

/* 3. 标题文字：字距加宽 */
.hero-content h1 {
  font-size: 3.5rem;
  /* 字号也可以稍微调大一点点 */
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.2;
  letter-spacing: 1.5px;
  /* ⬅️ 关键修改：增加字母间距，让标题字看起来更宽、更大气 */
}

/* 4. 描述段落：段落变宽、字距微调 */
.hero-description {
  font-size: 1.2rem;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.7;
  max-width: 650px;
  /* ⬅️ 关键修改：将原本的 500px 放宽到 650px，让文本横向更宽 */
  letter-spacing: 0.5px;
  /* 稍微增加字间距 */
}

/* 5. 右侧图片区 */
.hero-image-wrapper {
  flex: 0.9;
  /* 让图片区比例稍微小一点，给文字让位 */
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 2;
}

.hero-image {
  max-width: 100%;
  height: auto;
  max-height: 600px;
  object-fit: contain;
}

/* =========================================
   首屏左右进场动画 Keyframes
   ========================================= */
@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-in-left {
  animation: slideInLeft 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.animate-slide-in-right {
  animation: slideInRight 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  /* 可以稍微延迟一点让图片后出来 */
  animation-delay: 0.2s;
  opacity: 0;
  /* 配合 delay 初始隐藏 */
}

/* =========================================
   响应式调整 (移动端改为上下布局)
   ========================================= */
@media (max-width: 992px) {
  .hero-container {
    flex-direction: column;
    text-align: center;
    gap: 30px;
    padding-top: 40px;
  }

  .hero-content {
    text-align: center;
  }

  .hero-description {
    margin: 0 auto 30px auto;
  }

  .hero-image-wrapper {
    justify-content: center;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }
}



/* 1. 父容器 Banner 设置为相对定位 */
.banner {
  position: relative;
  width: 100%;
  height: 50vh;
  background-color: #0987fc;
  /* 假设是全屏 Banner */
  overflow: hidden;
}

/* 背景图处理同上 */
.background-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

/* 2. **核心调整：使用绝对定位精确控制** */
.text-content {
  position: absolute;
  /* **关键调整：设置距离底部的距离（底部对齐）** */
  /* 调整这个值（例如 10%）可以控制文字的高低 */
  bottom: 50%;

  /* 水平居中方法 */
  left: 50%;
  transform: translateX(-50%);
  /* 水平偏移 50% 实现精确居中 */

  text-align: center;
  /* 文字内部居中 */
  color: white;
  z-index: 1;
  width: 90%;
  /* 给一个最大宽度，防止文字太多时贴边 */
}

/* 进一步精细化文字样式 */
.text-content h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.text-content p {
  font-size: 1.2rem;
  font-weight: normal;
}

.hero-text h1 {
  font-size: 2.8rem;
  color: white;
  text-align: center;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.hero-products-container {
  width: 100%;
  max-width: 900px;
  margin-top: -150px;
  position: relative;
  z-index: 10;
  padding: 0 20px;
}

.product-group {
  width: 100%;
}

.product-group img {
  width: 100%;
  height: 300px;
}


.grid-container {
  display: grid;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.card {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.card-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.card h3 {
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.card p {
  color: #666;
  font-size: 0.95rem;
}

.feature-rows {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.feature-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}

.feature-row.reverse-row {
  flex-direction: row-reverse;
}

.feature-content {
  flex: 1;
}

.feature-content h3 {
  font-size: 1.8rem;
  margin-bottom: 20px;
}

.feature-content p {
  color: #555;
  font-size: 1.1rem;
}

.feature-image {
  flex: 1;
  height: 350px;
  border-radius: 16px;
  width: 100%;
}

.step-card {
  background: white;
  padding: 30px 20px;
  border-radius: 16px;
  border: 1px solid #eaeaea;

  /* 原有的悬浮和相对定位属性保持不变 */
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  /* ✨ 新增：让卡片内的标题(h4)和描述(p)也居中对齐，视觉上更统一 ✨ */
  text-align: center;
}

/* 修改图片占位符样式 */
.step-img {
  width: 60px;
  height: 60px;
  border-radius: 12px;

  /* ✨ 关键修改：上边距0，左右自动平分实现居中，下边距20px ✨ */
  margin: 0 auto 20px auto;

  /* 原有的占位符居中逻辑（如果替换为真实图片，以下两行可删） */
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-card h4 {
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.step-card p {
  font-size: 0.85rem;
  color: #666;
}

@media (max-width: 992px) {
  .hero-text h1 {
    font-size: 2.2rem;
  }

  .grid-3 {
    grid-template-columns: repeat(2, 1fr);
  }

  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }

  .feature-row,
  .feature-row.reverse-row {
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }

  .nav-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .hero-background {
    height: 400px;
  }

  .hero-products-container {
    margin-top: -100px;
  }

  .product-group {
    height: 200px;
  }

  .grid-3,
  .grid-4 {
    grid-template-columns: 1fr;
  }

  .feature-row,
  .feature-row.reverse-row {
    flex-direction: column-reverse;
    text-align: center;
    gap: 30px;
  }

  /* 移动端移除左右滑动，全部改为上下滑动以免体验撕裂 */
  .reveal-before-enter.slide-right,
  .reveal-before-enter.slide-left {
    transform: translateY(40px);
  }

  .feature-image {
    height: 250px;
  }
}

/* =========================================
   ✨ 语言选择器专属样式 ✨
========================================= */
.lang-selector {
  position: relative;
  margin-left: 25px;
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
}

.current-lang {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  transition: opacity 0.2s;
}

.current-lang:hover {
  opacity: 0.8;
}

/* 箭头动画 */
.arrow {
  font-size: 0.7rem;
  font-style: normal;
  transition: transform 0.3s ease;
}

.arrow-up {
  transform: rotate(180deg);
}

/* 下拉菜单面板 */
.lang-dropdown {
  position: absolute;
  top: 180%;
  /* 距离顶部的距离 */
  right: 0;
  background: #2a2a2a;
  /* 深色主题下拉框，贴合顶部导航的黑色 */
  color: #fff;
  list-style: none;
  padding: 8px 0;
  margin: 0;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  min-width: 180px;
  z-index: 200;
}

.lang-dropdown li {
  padding: 12px 20px;
  transition: background 0.2s, color 0.2s;
}

.lang-dropdown li:hover {
  background: #3a3a3a;
}

/* 当前选中语言的高亮样式 */
.lang-dropdown li.active {
  color: #409eff;
  /* 蓝色高亮 */
  font-weight: 600;
  background: #333;
}

/* Vue <transition name="dropdown"> 动画 */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.qr-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /* ✨ 关键修改：强制隐藏，并屏蔽鼠标事件 ✨ */
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;

  transform: scale(0.95);
  transition: all 0.3s ease;
  z-index: 10;
}

.step-card:hover .qr-overlay {
  /* ✨ 关键修改：悬浮时强制显示，并恢复鼠标事件 ✨ */
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transform: scale(1);
}

/* =========================================
   新增：Awesome Features (中间手机两侧卡片)
   ========================================= */
.awesome-features .section-title {
  margin-bottom: 15px;
  /* 缩小标题下间距给副标题留位 */
}

.section-subtitle {
  color: #666;
  font-size: 1.1rem;
  max-width: 700px;
  margin: 0 auto 60px auto;
}

/* 三列核心布局 */
.awesome-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 30px;
}

/* 左右卡片列占位 */
.awesome-column.left-column,
.awesome-column.right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* 卡片之间的垂直间距 */
}

/* 中间手机图片列占位 */
.awesome-column.center-column {
  flex: 0 0 350px;
  /* 固定中间列的宽度 */
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 10;
}

.phone-mockup {
  width: 100%;
  max-width: 320px;
  /* 加上一点阴影让手机浮起来 */
  filter: drop-shadow(0 25px 40px rgba(0, 0, 0, 0.15));
}

/* 卡片内部样式重写 */
.awesome-card {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: #ffffff;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);
  text-align: left;
  /* 卡片自身的微动效 */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.awesome-card:hover {
  transform: translateY(-5px) !important;
  /* 悬浮稍微上浮 */
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.08);
}

.feat-icon img {
  width: 45px;
  height: 45px;
  object-fit: contain;
  flex-shrink: 0;
}

.feat-text h4 {
  font-size: 1.25rem;
  margin-bottom: 8px;
  font-weight: 700;
  color: #111;
}

.feat-text p {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* --- 响应式适配 --- */
@media (max-width: 1024px) {
  .awesome-content {
    gap: 15px;
  }

  .awesome-card {
    padding: 15px;
  }

  .awesome-column.center-column {
    flex: 0 0 280px;
  }
}

@media (max-width: 768px) {

  /* 移动端改为上下堆叠布局 */
  .awesome-content {
    flex-direction: column;
    gap: 40px;
  }

  /* 让手机图片在移动端排到最上面（视觉顺序更好） */
  .awesome-column.center-column {
    order: -1;
    flex: auto;
    margin-bottom: 20px;
  }

  .phone-mockup {
    max-width: 260px;
  }
}
</style>